import { getStoreInfo } from '@/api/item';
import { updatePOrderZipcode } from '@/api/so';
import Constants from '@/constants/const';
import { setCookieToMemory, deleteCookie } from '@/utils/cookie';
import { getLang } from '@/utils/common/user';

export const syncZipcodeAndStore = async (params: { zipcode?: string; address_id?: number }) => {
  const lang = getLang();
  const res = await updatePOrderZipcode(params);
  if (res.result) {
    setCookieToMemory(Constants.ZIP_CODE, params.zipcode);
    let storeInfoResult = await getStoreInfo({ zipcode: params.zipcode });
    deleteCookie(Constants.WEEE_STORE);
    if (storeInfoResult?.result) {
      const storeInfo = storeInfoResult?.object || {};
      setCookieToMemory(Constants.STORE_INFO, JSON.stringify(storeInfo));
      //有设置store id时, 获取
      setCookieToMemory(Constants.WEEE_STORE, storeInfo.select_store || '');
    }
  }
  return res;
};
